<template>
    <div class="bg-nomad-900 rounded-xl p-6 min-w-0 flex flex-col gap-4">
        <h1 class="text-lg font-semibold text-white">YouTube URLs</h1>
        <div class=" text-sm">
            <div class="flex items-center gap-3">
                <input type="text" class="w-full rounded-lg bg-nomad-800 border border-nomad-700 text-white placeholder:text-nomad-400 focus:border-nomad-accent focus:ring-nomad-accent" placeholder="YouTube ID" v-model="youtube" />
                <button class="shrink-0 rounded-lg bg-nomad-accent text-nomad-900 font-semibold px-4 h-11 hover:bg-nomad-accent/80" @click="fetchYoutube">Fetch</button>
            </div>
        </div>
        <div class="text-sm text-nomad-100" v-if="message">{{ message }}</div>
        <div class="text-sm overflow-x-auto" v-if="contents && contents.length > 0">
            <table class="table-auto min-w-full divide-y divide-nomad-800">
                <thead>
                    <tr class="text-white">
                    <th class="px-2 py-3 text-start text-xs font-medium text-nomad-200 uppercase">resolution</th>
                    <th class="px-2 py-3 text-start text-xs font-medium text-nomad-200 uppercase">mime</th>
                    <th class="px-2 py-3 text-start text-xs font-medium text-nomad-200 uppercase">audio</th>
                    <th class="px-2 py-3 text-start text-xs font-medium text-nomad-200 uppercase">download</th>
                </tr>
                </thead>
                <tbody v-if="contents && contents.length > 0">
                    <tr v-for="video in contents" v-key="video.lastModified" class="text-white">
                        <td class="px-2 py-4 whitespace-nowrap">{{ video.quality }}</td>
                        <td class="px-2 py-4 whitespace-nowrap">{{ video.mimeType }}</td>
                        <td class="px-2 py-4 whitespace-nowrap">{{ video.audioQuality ?? video.qualityLabel }}</td>
                        <td class="px-2 py-4 whitespace-nowrap"><a :href="video.url" target="_blank" class="rounded-lg bg-nomad-accent text-nomad-900 font-semibold px-3 py-2" v-if="video.url">download</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            youtube: null,
            contents: null,
            message: null
        }
    },
    methods: {
        fetchYoutube() {
            this.message = null
            axios.get('/api/backstage/youtube-json/' + this.youtube)
                .then((response) => {
                    console.log(response)
                    if(response.data.message) {
                        this.message = response.data.message
                    } else {
                        this.contents = response.data
                    }
                })
        }
    }
}
</script>